import { render, staticRenderFns } from "./cfss-certification.component.vue?vue&type=template&id=c6e8b97a&"
import script from "./cfss-certification.component.ts?vue&type=script&lang=ts&"
export * from "./cfss-certification.component.ts?vue&type=script&lang=ts&"
import style0 from "./cfss-certification.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports